import {ReportsController} from "./reports.controller";
import {ReportPageController} from "./report-page.controller";
function reportsConfig($stateProvider) {


    $stateProvider
        .state('reports', {
            url: '/reports',
            parent: 'app-layout',
            template: require('./reports.html'),
            controller: 'ReportsController as Reports',
            params: {
                title: 'Report Page'
            }
        })
        .state('reports.page', {
            url: '/reports/{reportType}/generate',
            parent: 'app-layout',
            template: require('./report-page.html'),
            controller: 'ReportPageController as ReportPage',
            params: {
                title: 'Report Page'
            }
        })
}

export default angular.module('reports', [])
    .config(reportsConfig)
    .controller('ReportsController', ReportsController)
    .controller('ReportPageController', ReportPageController)



// WEBPACK FOOTER //
// ./modules/xray/states/reports/reports.module.js